import type { WizardStepId } from './types';

export interface GlowRotation {
    /** degrees, mobile / default breakpoint */
    default: number;
    /** degrees, md+ breakpoint; falls back to `default` when omitted */
    md?: number;
}

export interface GlowStep {
    /** glow rotation per breakpoint */
    rotation: GlowRotation;
    /**
     * Mobile-only horizontal offset of the glow centre from the viewport centre, in px
     * (`left: calc(50% + Npx)`). Desktop keeps its fixed left. Falls back to GLOW_LEFT_DEFAULT.
     */
    left?: number;
    /**
     * Mobile-only vertical offset of the glow centre from the viewport centre, in px
     * (`top: calc(50% + Npx)`). Desktop keeps its fixed top. Falls back to GLOW_TOP_DEFAULT.
     */
    top?: number;
}

/** Mobile glow centre's default offset from 50% (px) when a step omits `left`/`top`. */
export const GLOW_LEFT_DEFAULT = 305;
export const GLOW_TOP_DEFAULT = 436;

// Where the glow sits at each step. Values are eyeballed, not exact.
// Mobile (`default`): rotation + left/top tuned per step to match the Figma frames.
// Desktop (`md`): fixed anchor, rotation sweeps ~60°/step.
export const WIZARD_GLOW: Record<WizardStepId, GlowStep> = {
    unexpected: { rotation: { default: -130, md: -45 } },
    made: { rotation: { default: -140, md: -105 } },
    proud: { rotation: { default: -270, md: -165 } },
    about: { rotation: { default: -315, md: -225 }, top: 144 },
    submission: { rotation: { default: -386, md: -285 }, top: -250 },
    end: { rotation: { default: -394, md: -345 }, left: -772, top: 356 },
};
